module.exports = __webpack_public_path__ + "static/media/virgin-trains-logo-charcoal.97c3dcd8.svg";